export const BOSSES = [
  { id: 1112011, name: "Pondulum of Deem" },
  { id: 1112013, name: "Seawitch" },
  { id: 1112001, name: "Glorifrir Flintshoulder" },
  { id: 1112003, name: "Zombie Captain" },
  { id: 1112031, name: "Crocodile Bunbee" },
  { id: 1112033, name: "Crokolisk Minion" },
  { id: 1112021, name: "Crocolisk Dundee" },
  { id: 1112023, name: "Aligator Minion" },
  { id: 1112041, name: "Crocolisk Rundee" },
  { id: 1112043, name: "Aligator Guard" },
  { id: 1112051, name: "One-Three-Three-Seven" },
  { id: 1112053, name: "Ragnaros Qt" },
];
